export const DELETE_ALERT_PENDING = "DELETE_ALERT_PENDING";
export const DELETE_ALERT_ERROR = "DELETE_ALERT_ERROR";
export const DELETE_ALERT_SUCCESS = "DELETE_ALERT_SUCCESS";

export const CREATE_ALERT_PENDING = "CREATE_ALERT_PENDING";
export const CREATE_ALERT_ERROR = "CREATE_ALERT_ERROR";
export const CREATE_ALERT_SUCCESS = "CREATE_ALERT_SUCCESS";

export const UPDATE_ALERT_PENDING = "UPDATE_ALERT_PENDING";
export const UPDATE_ALERT_ERROR = "UPDATE_ALERT_ERROR";
export const UPDATE_ALERT_SUCCESS = "UPDATE_ALERT_SUCCESS";

export const deleteAlertPending = () => {
  return { type: DELETE_ALERT_PENDING };
};

export const deleteAlertSuccess = (payload) => {
  return { type: DELETE_ALERT_SUCCESS, payload };
};

export const deleteAlertError = (error) => {
  return { type: DELETE_ALERT_ERROR, error };
};

export const createAlertPending = () => {
  return { type: CREATE_ALERT_PENDING };
};

export const createAlertSuccess = (payload) => {
  return { type: CREATE_ALERT_SUCCESS, payload };
};

export const createAlertError = (error) => {
  return { type: CREATE_ALERT_ERROR, error };
};

export const updateAlertPending = () => {
  return { type: UPDATE_ALERT_PENDING };
};

export const updateAlertSuccess = (payload) => {
  return { type: UPDATE_ALERT_SUCCESS, payload };
};

export const updateAlertError = (error) => {
  return { type: UPDATE_ALERT_ERROR, error };
};
